module.exports = __webpack_public_path__ + "static/Heebo-VariableFont_wght-8c797536487197255c920304376d9d42.woff2";